import React from 'react';
import { ParentAdminOverviewController } from 'src/components/enterprise/Parents/Admin/ParentAdminOverviewController/ParentAdminOverviewController';
import { useCanAccessParentAdminFlows } from './hooks/useCanAccessParentAdminFlows/useCanAccessParentAdminFlows';

export const ParentAdminOverview: React.FC = () => {
  const isUserAllowedAccess = useCanAccessParentAdminFlows();

  if (!isUserAllowedAccess) {
    return null;
  }

  return <ParentAdminOverviewController />;
};
